export default Object.freeze({
  New: 1,
  Approved: 2,
  Objected: 3,
  Cancelled: 4,
});
